import React from 'react';
import useVisualViewport from 'Hooks/useVisibleViewport';
import './FloatingBottomFooter.css';

export const FloatingBottomFooter = ({ component, mobileOnly = false }) => {
  const { isObstructed } = useVisualViewport();
  return (
    <div className={`floatingFooter ${isObstructed && 'keyboardActive'} ${mobileOnly && 'mobileOnly'}`}>
      {component}
    </div>
  );
};
